// --- Utilitaires numériques et texte ---
function sum(...args) {
  return args.reduce((acc, v) => acc + (Number(v) || 0), 0);
}

function round(val, decimals = 0) {
  const factor = Math.pow(10, decimals);
  return Math.round(val * factor) / factor;
}

function concat(...args) {
  return args.map(x => (x == null ? "" : x.toString())).join("");
}

function daysBetween(d1, d2) {
  try {
    const ms = new Date(d1).getTime() - new Date(d2).getTime();
    return ms / (1000 * 60 * 60 * 24);
  } catch {
    return NaN;
  }
}

// --- Conversion nombre -> texte complet (FR) avec décimales ---
function numToText(n) {
  // Accepte "123,45" ou "123.45"
  if (typeof n === "string") n = Number(n.replace(",", "."));
  if (typeof n !== "number" || isNaN(n)) return "erreur nombre";

  const units = ["", "un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf"];
  const teens = ["dix", "onze", "douze", "treize", "quatorze", "quinze", "seize", "dix-sept", "dix-huit", "dix-neuf"];
  const tens  = ["", "", "vingt", "trente", "quarante", "cinquante", "soixante", "soixante", "quatre-vingt", "quatre-vingt"];

  function under100(num) {
    if (num < 10) return units[num];
    if (num < 20) return teens[num - 10];
    let t = Math.floor(num / 10), u = num % 10;
    if (t === 7 || t === 9) return tens[t] + (u === 1 ? " et " : "-") + teens[u];
    let sep = (u === 1 && t !== 8) ? " et " : (u > 0 ? "-" : "");
    return tens[t] + sep + (u > 0 ? units[u] : "");
  }
  function under1000(num) {
    if (num < 100) return under100(num);
    let c = Math.floor(num / 100), rest = num % 100;
    let cent = (c > 1 ? units[c] + " cent" : "cent");
    if (rest === 0 && c > 1) cent += "s";
    return cent + (rest > 0 ? " " + under100(rest) : "");
  }
  function integerToText(num) {
    if (num === 0) return "zéro";
    const scales = ["", "mille", "million", "milliard"];
    let parts = [], i = 0;
    while (num > 0) {
      const chunk = num % 1000;
      if (chunk > 0) {
        let text = under1000(chunk);
        if (i > 0) {
          if (i === 1 && chunk === 1) {
            text = scales[i]; // "mille"
          } else {
            text += " " + scales[i];
            if (chunk > 1 && i > 1) text += "s"; // millions, milliards
          }
        }
        parts.unshift(text);
      }
      num = Math.floor(num / 1000);
      i++;
    }
    return parts.join(" ").trim();
  }

  const sign = n < 0 ? "moins " : "";
  const abs  = Math.abs(n);
  const int  = Math.floor(abs);
  const dec  = Math.round((abs - int) * 100); // 2 décimales

  const intWords = integerToText(int);
  let out = sign + intWords;

  if (dec > 0) {
    // "virgule quatre" (0.4) / "virgule quarante-cinq" (0.45)
    out += " virgule " + (dec < 10 ? under100(dec) : under100(dec));
  }
  return out.trim();
}
// Helpers pour la date en FR
const MONTHS_FR = [
  "janvier","février","mars","avril","mai","juin",
  "juillet","août","septembre","octobre","novembre","décembre"
];

function parseDateFlexible(input) {
  if (input instanceof Date) return input;
  if (typeof input === "number") return new Date(input);

  if (typeof input === "string") {
    // ISO: YYYY-MM-DD
    let m = input.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));

    // FR: DD/MM/YYYY
    m = input.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (m) return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));

    // Fall-back natif
    const d = new Date(input);
    if (!isNaN(d)) return d;
  }
  return new Date(NaN);
}

function ucFirst(s) {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

// --- Conversion date -> texte ---
function dateToText(date, format = "DD/MM/YYYY") {
  try {
    const d = parseDateFlexible(date);
    if (isNaN(d.getTime())) return "erreur date";

    const day = d.getDate();
    const monthIdx = d.getMonth();
    const year = d.getFullYear();

    // Formats existants
    const pad = (x) => (x < 10 ? "0" + x : x);
    if (format === "DD/MM/YYYY") return `${pad(day)}/${pad(monthIdx + 1)}/${year}`;
    if (format === "MMMM YYYY")  return `${MONTHS_FR[monthIdx]} ${year}`;

    // Nouveau format demandé : "Vingt octobre deux mille vingt-cinq"
    if (format === "LONG_FR" || format === "LONG_FR_LOWER") {
      const dayWords  = (day === 1 ? "premier" : numToText(day));  // 1 -> premier
      const yearWords = numToText(year);                           // 2025 -> deux mille vingt-cinq
      const base = `${dayWords} ${MONTHS_FR[monthIdx]} ${yearWords}`;
      return (format === "LONG_FR") ? ucFirst(base) : base;
    }

    // Option utile : "20 octobre 2025"
    if (format === "D MMMM YYYY") {
      return `${day} ${MONTHS_FR[monthIdx]} ${year}`;
    }

    // Fallback
    return d.toDateString();
  } catch {
    return "erreur date";
  }
}
// --- Sélecteur à paires: WHEN(val, "A", resA, "B", resB, ..., default)
// Ex: when(etat_civil, "Marié", concat("Clause ", epoux_nom), "Divorcé", "Clause div", "")
function when(val, ...pairs) {
  const v = String(val).trim();
  for (let i = 0; i + 1 < pairs.length; i += 2) {
    const key = String(pairs[i]).trim();
    if (v === key) return pairs[i + 1];
  }
  return (pairs.length % 2 === 1) ? pairs[pairs.length - 1] : "";
}


// --- Mapping depuis 2 CSV parallèles (optionsCSV, textsCSV)
// Ex: pickFromCsv(etat_civil, "Célibataire,Marié,Divorcé", "...,Clause marié,...")
function pickFromCsv(selected, optionsCsv, textsCsv, optSep = ",", txtSep = ",") {
  const opts = String(optionsCsv || "").split(optSep).map(s => s.trim());
  const txts = String(textsCsv || "").split(txtSep).map(s => s.trim());
  const idx = opts.indexOf(String(selected || ""));
  return idx >= 0 ? (txts[idx] || "") : "";
}
// Comparaison sans accents / insensible à la casse
function _strip(s) {
  return String(s ?? "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();
}
function equals(a, b) { return _strip(a) === _strip(b); }

// Texte contient sous-texte
function contains(hay, needle) { return _strip(hay).includes(_strip(needle)); }

// IN avec CSV ("A,B,C")
function inCsv(val, csv, sep = ",") {
  const list = String(csv || "")
    .split(sep)
    .map(s => s.trim())
    .filter(Boolean)
    .map(_strip);
  return list.includes(_strip(val));
}

// IFNULL / COALESCE simple
function ifnull(a, b) { return (a ?? b); }


// --- Fonction principale ---
function evaluateFormula(formula, values) {
  if (!formula || !String(formula).trim()) return "";

  let expr = String(formula);

  // 1) Agrégations sur tableau: SUM(array.field) / MAX / MIN
  //    -> Déroule en liste de nombres (ex: sum(12,34,0))
  expr = expr.replace(
    /SUM\s*\(\s*([a-zA-Z0-9_]+)\.([a-zA-Z0-9_]+)\s*\)/g,
    (_, arr, prop) => {
      const rows = Array.isArray(values?.[arr]) ? values[arr] : [];
      const nums = rows.map(r => Number(r?.[prop]) || 0);
      return `sum(${nums.join(",")})`;
    }
  );
  expr = expr.replace(
    /(MAX|MIN)\s*\(\s*([a-zA-Z0-9_]+)\.([a-zA-Z0-9_]+)\s*\)/g,
    (_, fn, arr, prop) => {
      const rows = Array.isArray(values?.[arr]) ? values[arr] : [];
      const nums = rows.map(r => Number(r?.[prop]) || 0);
      const call = fn === "MAX" ? "Math.max" : "Math.min";
      return `${call}(${nums.join(",")})`;
    }
  );

  // 2) Substituer les variables scalaires uniquement
  Object.keys(values || {}).forEach((key) => {
    const val = values[key];
    if (Array.isArray(val)) return;

    const re = new RegExp(`\\b${key.replace(/[.*+?^${}()|[\\]\\\\]/g, "\\$&")}\\b`, "g");

    let injected;
    if (val instanceof Date) {
      // Date -> ISO 'YYYY-MM-DD'
      injected = JSON.stringify(val.toISOString().slice(0,10));
    } else if (typeof val === "string") {
      // 'DD/MM/YYYY' -> 'YYYY-MM-DD'
      const m = val.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      injected = JSON.stringify(m ? `${m[3]}-${m[2]}-${m[1]}` : val);
    } else if (val === undefined || val === null) {
      injected = "null";
    } else {
      injected = String(val);
    }

    expr = expr.replace(re, injected);
  });
  // --- Helper pour convertir IF(cond, a, b) en (cond ? a : b) en respectant () et " "
  function transformIF(s) {
    // remplace IF( par un marqueur pour parser proprement
    s = s.replace(/IF\s*\(/g, "__IF__(");
    while (s.includes("__IF__(")) {
      const i = s.indexOf("__IF__(");
      let j = i + 7, depth = 1, inStr = false, q = null, esc = false;
      const buf = [];
      for (; j < s.length; j++) {
        const ch = s[j];
        if (inStr) {
          buf.push(ch);
          if (esc) { esc = false; continue; }
          if (ch === "\\") { esc = true; continue; }
          if (ch === q) { inStr = false; q = null; }
          continue;
        }
        if (ch === "'" || ch === '"') { inStr = true; q = ch; buf.push(ch); continue; }
        if (ch === "(") { depth++; buf.push(ch); continue; }
        if (ch === ")") { depth--; if (depth === 0) break; buf.push(ch); continue; }
        buf.push(ch);
      }
      const inside = buf.join("");
      // split top-level args by comma
      let args = [], cur = "", d = 0, sIn = false, sQ = null, sEsc = false;
      for (let k = 0; k < inside.length; k++) {
        const c = inside[k];
        if (sIn) {
          cur += c;
          if (sEsc) { sEsc = false; continue; }
          if (c === "\\") { sEsc = true; continue; }
          if (c === sQ) { sIn = false; sQ = null; }
          continue;
        }
        if (c === "'" || c === '"') { sIn = true; sQ = c; cur += c; continue; }
        if (c === "(") { d++; cur += c; continue; }
        if (c === ")") { d--; cur += c; continue; }
        if (c === "," && d === 0) { args.push(cur.trim()); cur = ""; continue; }
        cur += c;
      }
      if (cur.trim().length) args.push(cur.trim());
      if (args.length !== 3) break; // sécurité

      const repl = `(${args[0]} ? ${args[1]} : ${args[2]})`;
      s = s.slice(0, i) + repl + s.slice(j + 1);
    }
    return s;
  }
  expr = transformIF(expr); // <<< AJOUTE ÇA

  // 3) Traduction Excel-like
  expr = expr
    //.replace(/IF\s*\(([^,]+),([^,]+),([^)]+)\)/g, "($1 ? $2 : $3)")
    .replace(/SUM\s*\(([^)]+)\)/g, "sum($1)")      // garde la compatibilité SUM(a,b,c)
    .replace(/MAX\s*\(([^)]+)\)/g, "Math.max($1)")
    .replace(/MIN\s*\(([^)]+)\)/g, "Math.min($1)")
    .replace(/ROUND\s*\(([^,]+),([^)]+)\)/g, "round($1,$2)")
    .replace(/CONCAT\s*\(([^)]+)\)/g, "concat($1)")
    .replace(/UPPER\s*\(([^)]+)\)/g, "(String($1 ?? \"\").toUpperCase())")
    .replace(/LOWER\s*\(([^)]+)\)/g, "(String($1 ?? \"\").toLowerCase())")
    .replace(/LEN\s*\(([^)]+)\)/g, "(String($1 ?? \"\").length)")
    .replace(/TODAY\(\)/g, "new Date()")
    .replace(/YEAR\s*\(([^)]+)\)/g, "(new Date($1)).getFullYear()")
    .replace(/MONTH\s*\(([^)]+)\)/g, "(new Date($1)).getMonth()+1")
    .replace(/DAYS\s*\(([^,]+),([^)]+)\)/g, "daysBetween($1,$2)")
    .replace(/NUMTOTEXT\s*\(([^)]+)\)/g, "numToText($1)")
    .replace(/DATETOTEXT\s*\(\s*([^)]+?)\s*,\s*(['"])([^'"]+)\2\s*\)/g, "dateToText($1,'$3')")
    .replace(/DATETOTEXT\s*\(\s*([^)]+?)\s*\)/g, "dateToText($1,'LONG_FR')")
    .replace(/EQUALS\s*\(([^,]+),([^)]+)\)/g, "equals($1,$2)")
    .replace(/CONTAINS\s*\(([^,]+),([^)]+)\)/g, "contains($1,$2)")
    .replace(/IN\s*\(([^,]+),([^)]+)\)/g, "inCsv($1,$2)")
    .replace(/IFNULL\s*\(([^,]+),([^)]+)\)/g, "ifnull($1,$2)");
  const context = {
    sum, round, concat, daysBetween, numToText, dateToText, Math,
    when,            // nouvel helper
    WHEN: when,      // alias si l'éditeur écrit en majuscules
    pickFromCsv,      // mapping CSV -> texte
    equals, contains, inCsv, ifnull
  };


  try {
    const fn = new Function(...Object.keys(context), `return ${expr};`);
    const result = fn(...Object.values(context));
    if (result === undefined) return "erreur: champ manquant";
    return result;
  } catch (e) {
    console.error("Erreur formule:", expr, e);
    return "erreur formule";
  }
}
// [ok] Exports pour React
export { evaluateFormula, numToText, dateToText };
